import { v5 } from 'uuid';

/** Vendor OpenAPI caps `content` at 120000 chars; over that the whole batch 422s. */
export const DECEPTIO_MAX_CONTENT_CHARS = 120000;
export const DECEPTIO_TURN_EXTRACTOR = 'deceptio-turn-v1';
export const DECEPTIO_TURN_TRACK_PREFIX = 'Deceptio answers ';

function deceptioUuidName(...parts: unknown[]): string {
  return JSON.stringify([DECEPTIO_TURN_EXTRACTOR, ...parts]);
}

export function deceptioTurnTrackId(jobId: string, speakerId: string): string {
  return v5(deceptioUuidName('track', jobId, speakerId), v5.URL);
}

export function isDeceptioTurnTrack(
  track: { id: string; jobId: string; name: string },
): boolean {
  if (!track.name.startsWith(DECEPTIO_TURN_TRACK_PREFIX)) return false;
  const speakerId = track.name.slice(DECEPTIO_TURN_TRACK_PREFIX.length);
  return !!speakerId && track.id === deceptioTurnTrackId(track.jobId, speakerId);
}

/**
 * The exact string to submit as `content` for a moment, or '' when there is nothing to analyse.
 *
 * Lives in the shared lib because BOTH sides of the round trip have to agree on it. The backend
 * submits this string and the vendor's rule `ranges` are character offsets into it; the analysis
 * window then slices those offsets to highlight the flagged words. When the window rebuilt the
 * string with a plain .trim(), a NUL anywhere before a range shifted every later offset right by
 * one and the popup silently underlined the wrong words.
 *
 * Eligibility and submission MUST run this same transform too. They used to differ -- eligibility
 * judged `description` with NULs stripped while the submission posted the raw field -- so an answer
 * could be admitted on one string and sent as another. NUL is stripped because emptiness has to be
 * judged the way the VENDOR judges it: Laravel's `required` runs PHP trim(), whose default charlist
 * includes "\0", the one character JS trim() leaves behind.
 *
 * Answers now span a whole spoken turn rather than one sentence, so length is no longer bounded by
 * accident and the vendor cap has to be enforced here.
 */
export function sanitizeDeceptioContent(description?: string | null): string {
  return (description ?? '').replace(/\0/g, '').trim().slice(0, DECEPTIO_MAX_CONTENT_CHARS);
}
